function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-6.55672e-08 1.5C-7.76377e-08 1.77614 0.223858 2 0.5 2L15.5 2C15.7761 2 16 1.77615 16 1.5L16 0.500001C16 0.223859 15.7761 -9.78512e-09 15.5 -2.18557e-08L0.5 -6.77523e-07C0.223858 -6.89593e-07 -9.78515e-09 0.223857 -2.18557e-08 0.5L-6.55672e-08 1.5ZM15.5 4C15.7761 4 16 4.22386 16 4.5L16 5.5C16 5.77614 15.7761 6 15.5 6L0.5 6C0.223858 6 -2.52483e-07 5.77614 -2.40413e-07 5.5L-1.96701e-07 4.5C-1.84631e-07 4.22386 0.223858 4 0.5 4L15.5 4ZM15.5 8C15.7761 8 16 8.22386 16 8.5L16 9.5C16 9.77614 15.7761 10 15.5 10L0.5 10C0.223857 10 -4.27329e-07 9.77614 -4.15258e-07 9.5L-3.71547e-07 8.5C-3.59476e-07 8.22386 0.223858 8 0.5 8L15.5 8Z",
  fill: "white"
});

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.f714e05e.svg";
export { ForwardRef as ReactComponent };